import React from 'react';
import { readableTemplateLabel } from './templateKeyPresentation';

const ACTION_LABELS = {
  TEMPLATE_CREATED: 'Şablon oluşturuldu',
  TEMPLATE_UPDATED: 'Şablon güncellendi',
  TEMPLATE_SUBMITTED: 'İncelemeye gönderildi',
  TEMPLATE_APPROVED: 'Şablon onaylandı',
  TEMPLATE_REJECTED: 'Şablon reddedildi',
  TEMPLATE_ACTIVATED: 'Şablon yayına alındı',
  TEMPLATE_ARCHIVED: 'Şablon arşivlendi',
  TEMPLATE_RESTORED: 'Şablon geri alındı',
  create: 'Şablon oluşturuldu',
  update: 'Şablon güncellendi',
  submit: 'İncelemeye gönderildi',
  approve: 'Şablon onaylandı',
  reject: 'Şablon reddedildi',
  activate: 'Şablon yayına alındı',
  archive: 'Şablon arşivlendi'
};

function actionLabel(actionType) {
  const raw = String(actionType || '').trim();
  if (!raw) return 'Bilinmeyen işlem';
  return ACTION_LABELS[raw] || ACTION_LABELS[raw.toUpperCase()] || raw;
}

function formatDate(value) {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString('tr-TR');
  } catch (_err) {
    return String(value);
  }
}

export default function AuditLogTable({ rows = [] }) {
  if (!rows.length) {
    return <p className="text-sm text-slate-500">Henüz denetim kaydı bulunmuyor.</p>;
  }

  return (
    <div className="space-y-2">
      {(rows || []).slice(0, 20).map((log) => (
        <div key={log.id} className="rounded-lg border border-slate-200 dark:border-slate-800 p-2 text-xs">
          <p className="font-bold text-slate-700 dark:text-slate-200">{actionLabel(log.action_type)}</p>
          <p className="text-slate-700 dark:text-slate-300">{readableTemplateLabel(log.template_key, null).title}</p>
          <p className="text-slate-500">{readableTemplateLabel(log.template_key, null).technicalKey} · {formatDate(log.created_at)}</p>
        </div>
      ))}
    </div>
  );
}
